import { Editor, Extension } from '@tiptap/core'
import { createLockedItemsPlugin, lockedItemsPluginKey, LockedItemsPluginOptions } from './locked-items-plugin'

export const LockedItemsExtension = Extension.create<LockedItemsPluginOptions>({
  name: 'lockedItems',

  addOptions() {
    return {
      getLockedTemplateItemIds: () => [],
    }
  },

  addProseMirrorPlugins() {
    return [createLockedItemsPlugin({ getLockedTemplateItemIds: this.options.getLockedTemplateItemIds })]
  },
})

/**
 * Nudge the plugin to re-read the locked set. It changes when the meeting is refetched rather than through an
 * editor transaction, so without a transaction to react to the plugin would never look again.
 */
export function refreshLockedItems(editor: Editor) {
  editor.view.dispatch(editor.state.tr.setMeta(lockedItemsPluginKey, {}))
}
